import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./style.module.css";
import "./ScrollLineGSAP.css";
import {Image} from 'react-bootstrap'
import TopNavbar from "../navbar/TopNavbar";
import Footer from "../footer/Footer";
const events = {
  2025: [
    {
      month: "June 2025",
      title: "AI Conference Launch",
      description: "Discussing trends in generative models and automation.",
    },
    {
      month: "July 2025",
      title: "Developer Summit",
      description:
        "Global meetup for React Native professionals and community demos.",
    },
    {
      month: "August 2025",
      title: "Cybersecurity Expo",
      description:
        "Emerging technologies in digital security and blockchain identity.",
    },
    {
      month: "September 2025",
      title: "SaaS Growth Forum",
      description:
        "Networking and strategy for scaling SaaS startups globally.",
    },
  ],
  2026: [
    {
      month: "January 2026",
      title: "Smart Cities Meetup",
      description: "Urban innovation and smart infrastructure technologies.",
    },
    {
      month: "March 2026",
      title: "Quantum AI Symposium",
      description: "Exploring the future of quantum computing in AI.",
    },
  ],
  2027: [
    {
      month: "May 2027",
      title: "Virtual Reality World",
      description:
        "A deep dive into immersive VR technologies and storytelling.",
    },
    {
      month: "August 2027",
      title: "GreenTech Expo",
      description: "Innovations in sustainability, energy, and climate tech.",
    },
  ],
};

gsap.registerPlugin(ScrollTrigger);

export default function EventSection() {
  const lineRef = useRef(null);

  useEffect(() => {
    const length = lineRef.current.getTotalLength();

    // Set initial dash style
    lineRef.current.style.strokeDasharray = length;
    lineRef.current.style.strokeDashoffset = length;

    gsap.to(lineRef.current, {
      strokeDashoffset: 0,
      ease: "power1.out",
      scrollTrigger: {
        trigger: lineRef.current,
        start: "top 80%",
        end: "bottom 10%",
        scrub: true,
      },
    });
  }, []);
  // Flatten and map events with vertical position (dy = spacing)
  const timelineItems = [];
  let y = 50;
  const spacing = 80;

  Object.entries(events).forEach(([year, items]) => {
    timelineItems.push({ type: "year", label: year, y });
    y += spacing;
    items.forEach((item) => {
      timelineItems.push({ type: "month", ...item, y });
      y += spacing;
    });
  });

  return (
    <div style={{
        backgroundColor:"#f0f0f0",
        width:"100%",
        height:"100%"
            }}>
                <TopNavbar/>
                <br></br> <br></br> <br></br><br></br><br></br>
    {/* <div style={{height:"80vh",width:"100%",background:"#f0f0f0"}}>
        <Image src="https://udaipurblog.com/wp-content/uploads/2021/03/consumer-day-facts-website-thumb.jpg"  style={{width:"100%",height:"100%",objectFit:"contain"}}/>
        
    </div> */}
   <div
  style={{
     height: `${y + 200}px`,
    padding: "10px 0",
    width: "100%",
    backgroundImage: `url("https://udaipurblog.com/wp-content/uploads/2021/03/consumer-day-facts-website-thumb.jpg")`,         // Cover entire container
    backgroundPosition: "center",    // Center image
    backgroundRepeat: "no-repeat",   // No tiling
    position: "relative",            // Optional for overlays
    
  }}
>
      <svg
        height={y + 200}
        width="90%"
        style={{ display: "block", margin: "0 auto" }}
      >
        {/* Vertical Line */}
        {/* <line
  x1="50"
  y1="0"
  x2="50"
  y2={y}
  stroke="red"
  strokeWidth="4"
  strokeDasharray="10 10" // dashed pattern
/> */}

        <line
          ref={lineRef}
          x1="50"
          y1="0"
          x2="50"
          y2={y}
          stroke="#007bff"
          strokeWidth="4"
          strokeDasharray={y}
          strokeDashoffset={y}
        />

        {/* Circles and labels */}
        {timelineItems.map((item, index) => (
          <React.Fragment key={index}>
            <circle
              cx="50"
              cy={item.y}
              r={item.type === "year" ? 8 : 5}
              fill={item.type === "year" ? "#007bff" : "#00b894"}
            />
            <text
              x="70"
              y={item.y + 5}
              fontSize="20"
              fill="#333"
              fontWeight={item.type === "year" ? "bold" : "normal"}
            >
              {item.type === "year" ? item.label : item.month}
            </text>
            {item.type === "month" && (
              <text x="70" y={item.y + 20} fontSize="15" fill="#555" style={{marginTop:5}}>
                {item.title}
              </text>
            )}
          </React.Fragment>
        ))}
      </svg>
    </div>
    <Footer/>
    </div>
  );
}
